import { useState } from 'react';

import useSWR from 'swr';

// Utils
import { get } from '@/utils/client';
import { injectEndpointUrlParams } from '@/utils/injectEndpointUrlParams';

// API Endpoints
import { LABELS } from '@/lib/routes/apiEndpoints';

const useLabels = ({
    activeSPID = undefined,
    options = {},
    params = undefined,
    shouldFetch = true
} = {}) => {
    const [requestParams, setRequestParams] = useState(params);

    const apiEndpoint = injectEndpointUrlParams(LABELS, {
        SPID: activeSPID
    });
    const {
        data: labels,
        mutate: mutateLabels,
        error: errorLabels,
        isLoading
    } = useSWR(
        shouldFetch
            ? [apiEndpoint, requestParams ? JSON.stringify(requestParams) : undefined]
            : null,
        ([url]) => get(url, requestParams).then((res) => res.data?.data),
        {
            shouldRetryOnError: false,
            keepPreviousData: true, // Keep previous data while fetching new search results
            ...options
        }
    );

    return {
        labels,
        mutateLabels,
        errorLabels,
        isLoading,
        isLoadingInitialData: isLoading && !labels,
        requestParams,
        setRequestParams
    };
};

export default useLabels;
